module.exports = __webpack_public_path__ + "static/media/daniela-mayumi.3453f7ff.jpeg";